import { render, staticRenderFns } from "./detail-wrapper.vue?vue&type=template&id=50ccaaa7&"
import script from "./detail-wrapper.vue?vue&type=script&lang=ts&"
export * from "./detail-wrapper.vue?vue&type=script&lang=ts&"
import style0 from "./detail-wrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports